import FAQList from './FAQList';
import { FAQListProps, FAQListValueProps } from './types';

export type { FAQListProps, FAQListValueProps };
export default FAQList;
